import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

type AlarmSummaryFooterProps = {
  graphButton: () => void;
  bulkButton: () => void;
  deleteButton: () => void;
  count: number;
};

const useStyles = makeStyles(
  createStyles({
    button: {
      marginTop: '15px',
      marginLeft: '40px',
      alignItems: 'center',
    },
    countBox: {
      margin: '0px 8px',
      borderStyle: 'solid',
      borderWidth: 'thin',
      borderColor: 'black',
      borderRadius: '6px',
      padding: '2px 12px',
    },
  })
);

const AlarmSummaryFooter: React.FC<AlarmSummaryFooterProps> = (props: AlarmSummaryFooterProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <Grid container>
        <Grid item xs={2}>
          <Button variant="contained" color="primary" className={classes.button} onClick={(e) => props.bulkButton()}>
            {t('AlarmSummaryFooter.一括確認','一括確認')}
          </Button>
        </Grid>
        {/* <Grid item xs={2}>
          <Button variant="contained" color="primary" className={classes.button} onClick={(e) => props.deleteButton()}>
          {t('AlarmSummaryFooter.削除','削除')}
          </Button>
        </Grid> */}
        <Grid item xs={3}>
          <div style={{ marginTop: '20px' }}>
            <span>{t('AlarmSummaryFooter.未確認件数','未確認件数')}</span>
            <span className={classes.countBox}>{props.count}</span>
            <span>{t('AlarmSummaryFooter.件','件')}</span>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default AlarmSummaryFooter;
